import { api } from '@/api/api'
import { endpoints } from '@/api/endpoints'
import {
  SignInDTO,
  VerifyCodeDTO,
  VerifyPasswordDTO,
  SocialSignIndDTO,
  SetupPasswordDTO,
  SetupProfileDTO,
  SignInWithPhonePayload,
  SignInWithEmailPayload,
  SocialSignInPayload,
  CheckCodeSentToPhonePayload,
  CheckCodeSentToEmailPayload,
  SendCodeToPhonePayload,
  SendCodeToPhoneDTO,
  VerifyPasswordPayload,
  SetupPasswordPayload,
  SetupProfilePayload,
  TelegramInitiatePayload,
  TelegramInitiateDTO,
  TelegramLinkAccountPayload,
  TelegramLinkOauthPayload,
  TelegramLinkDTO,
  CheckRecoveryCodeSentToEmailPayload,
  SendRecoveryCodeToEmailPayload,
  RecoveryCodeDTO,
  SendRecoveryCodeToPhonePayload,
  CheckRecoveryCodeSentToPhonePayload,
  RecoverPasswordPayload,
  RecoverPasswordDTO,
} from './authTypes'

// ======== PHONE AUTH ==============
async function signInWithPhone(
  payload: SignInWithPhonePayload,
): Promise<SignInDTO> {
  const res = await api.post(endpoints.auth.phoneSignin, payload)
  return res.data
}

async function sendCodeToPhone(
  payload: SendCodeToPhonePayload,
): Promise<SendCodeToPhoneDTO> {
  const res = await api.post(endpoints.auth.phoneSendCode, payload)
  return res.data
}

async function checkCodeSentToPhone(
  payload: CheckCodeSentToPhonePayload,
): Promise<VerifyCodeDTO> {
  const res = await api.post(endpoints.auth.phoneVerifyCode, payload)
  return res.data
}

// ======== EMAIL AUTH ==============
async function signInWithEmail(
  payload: SignInWithEmailPayload,
): Promise<SignInDTO> {
  const res = await api.post(endpoints.auth.emailSignin, payload)
  return res.data
}

async function checkCodeSentToEmail(
  payload: CheckCodeSentToEmailPayload,
): Promise<VerifyCodeDTO> {
  const res = await api.post(endpoints.auth.emailVerifyCode, payload)
  return res.data
}

// ======== SOCIAL AUTH ==============
async function signInWithApple(
  payload: SocialSignInPayload,
): Promise<SocialSignIndDTO> {
  const res = await api.post(endpoints.auth.appleSignin, payload)
  return res.data
}

async function signInWithGoogle(
  payload: SocialSignInPayload,
): Promise<SocialSignIndDTO> {
  const res = await api.post(endpoints.auth.googleSignin, payload)
  return res.data
}

// ======== TELEGRAM AUTH ==============
async function telegramInitiate(
  payload: TelegramInitiatePayload,
): Promise<TelegramInitiateDTO> {
  const res = await api.post(endpoints.auth.telegramInitiate, payload)
  return res.data
}

async function telegramLinkAccount(
  payload: TelegramLinkAccountPayload,
): Promise<TelegramLinkDTO> {
  const res = await api.post(endpoints.auth.telegramLinkAccount, payload)
  return res.data
}

async function telegramLinkOauth(
  payload: TelegramLinkOauthPayload,
): Promise<TelegramLinkDTO> {
  const res = await api.post(endpoints.auth.telegramLinkOauth, payload)
  return res.data
}

// ======== PASSWORD ==============
async function verifyPassword(
  payload: VerifyPasswordPayload,
): Promise<VerifyPasswordDTO> {
  const res = await api.post(endpoints.auth.verifyPassword, payload)
  return res.data
}

async function setupPassword(
  payload: SetupPasswordPayload,
): Promise<SetupPasswordDTO> {
  const res = await api.post(endpoints.auth.setupPassword, payload)
  return res.data
}

// ======== PROFILE ==============
async function setupProfile(
  payload: SetupProfilePayload,
): Promise<SetupProfileDTO> {
  const res = await api.patch(endpoints.identity.setupProfile, payload)
  return res.data
}

// ======== LOGOUT ==============
async function logout(): Promise<any> {
  const res = await api.post(endpoints.auth.logout)
  return res.data
}

// ======== RECOVERY CODE WITH EMAIL ==============
async function sendRecoveryCodeToEmail(
  payload: SendRecoveryCodeToEmailPayload,
): Promise<RecoveryCodeDTO> {
  const res = await api.post<RecoveryCodeDTO>(
    endpoints.auth.sendRecoveryCodeToEmail,
    payload,
  )

  return res.data
}

async function checkRecoveryCodeSentToEmail(
  payload: CheckRecoveryCodeSentToEmailPayload,
): Promise<VerifyCodeDTO> {
  const res = await api.post(
    endpoints.auth.checkRecoveryCodeSentToEmail,
    payload,
  )

  return res.data
}

// ======== RECOVERY CODE WITH PHONE ==============
async function sendRecoveryCodeToPhone(
  payload: SendRecoveryCodeToPhonePayload,
): Promise<RecoveryCodeDTO> {
  const res = await api.post<RecoveryCodeDTO>(
    endpoints.auth.sendRecoveryCodeToPhone,
    payload,
  )

  return res.data
}

async function checkRecoveryCodeSentToPhone(
  payload: CheckRecoveryCodeSentToPhonePayload,
): Promise<VerifyCodeDTO> {
  const res = await api.post(
    endpoints.auth.checkRecoveryCodeSentToPhone,
    payload,
  )

  return res.data
}

// ======== RECOVER PASSWORD ==============
async function recoverPassword(
  payload: RecoverPasswordPayload,
): Promise<RecoverPasswordDTO> {
  const res = await api.post<RecoverPasswordDTO>(
    endpoints.auth.recoverPassword,
    payload,
  )

  return res.data
}

export const authApi = {
  signInWithPhone,
  sendCodeToPhone,
  checkCodeSentToPhone,
  signInWithEmail,
  checkCodeSentToEmail,
  signInWithApple,
  signInWithGoogle,
  telegramInitiate,
  telegramLinkAccount,
  telegramLinkOauth,
  verifyPassword,
  setupPassword,
  setupProfile,
  logout,
  sendRecoveryCodeToEmail,
  checkRecoveryCodeSentToEmail,
  sendRecoveryCodeToPhone,
  checkRecoveryCodeSentToPhone,
  recoverPassword,
}
